/**
 * 문제집 목록 컴포넌트
 * 배정된 문제집들을 진행중/완료 분리하여 표시
 */

import React from 'react';
import { AssignedWorkbook } from '../../types/workbook';
import { WorkbookCard } from './WorkbookCard';

/**
 * WorkbookList 컴포넌트 Props
 */
interface WorkbookListProps {
  /** 배정된 문제집 목록 */
  assignments: AssignedWorkbook[];
  /** 문제집 선택 핸들러 */
  onSelectWorkbook: (workbookName: string) => void;
}

/**
 * 문제집 목록 컴포넌트
 *
 * - 진행중인 문제집과 완료된 문제집을 분리하여 표시
 * - 그리드 레이아웃 (반응형: 모바일 1열, 태블릿 이상 2열)
 * - 각 섹션에 제목 및 아이콘 표시
 */
export const WorkbookList: React.FC<WorkbookListProps> = ({
  assignments,
  onSelectWorkbook,
}) => {
  // 완료/미완료 분리
  const inProgress = assignments.filter((a) => !a.is_completed);
  const completed = assignments.filter((a) => a.is_completed);

  return (
    <div className="space-y-8">
      {/* 진행 중인 문제집 */}
      {inProgress.length > 0 && (
        <div>
          <h2 className="font-pixel text-xl text-[#9bbc0f] mb-4 flex items-center gap-2">
            🎯 진행 중
            <span className="text-sm text-gray-400">({inProgress.length})</span>
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {inProgress.map((assignment) => (
              <WorkbookCard
                key={assignment.workbook_name}
                assignment={assignment}
                onSelect={onSelectWorkbook}
              />
            ))}
          </div>
        </div>
      )}

      {/* 완료된 문제집 */}
      {completed.length > 0 && (
        <div>
          <h2 className="font-pixel text-xl text-gray-500 mb-4 flex items-center gap-2">
            ✅ 완료
            <span className="text-sm text-gray-600">({completed.length})</span>
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {completed.map((assignment) => (
              <WorkbookCard
                key={assignment.workbook_name}
                assignment={assignment}
                onSelect={onSelectWorkbook}
              />
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
